import { GetOneAppointmentResponseService } from "../../../../services/TurnServices/Turns.type";
import { EditTurnType } from "../types";
import { getBasicMetadata } from "./getAppointmentInfo";
import {
  selectionEqualToAppointment,
  dateTimeSelectionEqualToAppointment,
} from "./selectionEqualToAppointment";

export const checkRulesBeforeUpdate = (
  data: EditTurnType,
  appointment?: GetOneAppointmentResponseService,
) => {
  if (appointment?.metadata && selectionEqualToAppointment({ exam: data.exam?.id, molde: data.molde?.id, practices: data.practicesSelected?.map((p) => p.id), },
    getBasicMetadata(appointment.metadata),
  )
    // &&
    // dateTimeSelectionEqualToAppointment(
    //   {
    //     date: data.date,
    //     time: data.hour?.value,
    //   },
    //   { date: appointment?.date, time: appointment?.startTime },
    // )
  )
    throw new Error("Error en funcion checkRulesBeforeUpdate");
};
